
import { Button } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const SaveButton = ({ label, onClick })=> {

    return (
      <Button variant="outlined" onClick={onClick} startIcon={<SaveAltIcon />}
      sx={{
        color: 'primary.main',
        padding: '4px 8px',
        ml:'16px',
      }}
      
      
      >
      {label}
    </Button>
    );
  };

  export default SaveButton